import * as React from 'react';
import YouTube from 'react-youtube';

type YouTubePlayerProps = {
  episode: {
    id: number,
    youtube_id: string,
  },
  onFinish: Function,
}
export default class YouTubePlayer extends React.Component<YouTubePlayerProps> {
  constructor(props) {
    super(props);
  }

  render() {
    const { episode, onFinish } = this.props;
    const opts = {
      width: '100%',
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 1, 
        modestbranding: 1,
        iv_load_policy: 3,
      }
    };
    return (
      <div className="YouTubePlayer">
        <YouTube videoId={episode.youtube_id} 
          opts={opts}
          onEnd={() => onFinish() }  />
      </div>
    );
  }
}

